import { useDispatch } from 'react-redux'
import Button from '../Buttons'
import { setAllReferences, setContent, setDrafts, setReferences, setSetup, setSetupChanged } from '../../redux/docSlice'
import './_Revert.scss'
import Modal from './Modal'

function Revert({ docID, closeModal, isOpen }: { docID: string; closeModal: () => void; isOpen: boolean }) {
	const dispatch = useDispatch()

	function revertEssay(docID: string) {
		dispatch(setSetup({ docID, setup: false }))
		dispatch(setSetupChanged({ docID, setupChanged: true }))
		dispatch(setContent({ docID, content: '' }))
		dispatch(setDrafts({ docID, drafts: [] }))
		closeModal()
	}

	return (
		<Modal open={isOpen} closeModal={closeModal} portalClassName="revert">
			<h5 className="header-md">Are you sure you want to restart?</h5>
			<p>Your current content will be lost.</p>
			<div className="flex justify-between gap-2">
				<Button
					type="ghost"
					onClick={() => {
						closeModal()
					}}
					className="text-xl grow"
				>
					<span>No</span>
				</Button>
				<Button type="ghost" onClick={() => revertEssay(docID)} className="text-xl grow">
					<span>Yes</span>
				</Button>
			</div>
		</Modal>
	)
}

export default Revert
